import styled from "@emotion/styled";
export const FooterText = styled.span`
  font-family: Roboto;
  font-weight: 400;
  font-size: 14px;
  line-height: 16.41px;
  letter-spacing: 0%;
  word-wrap: break-word;
  white-space: normal;
  color: #ffffff;
  `;
export const StyledFooterContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 66px;
    max-height: 66px;
    background-color: #003B21;
    padding: 24px;
    @media (max-width: 768px) {
    justify-content: center;
    text-align: center
    }
  `;